const NomenclatureEnum = {
    building: "/04",
    explosion: "/06",
    registery: "/04/05"
}
export default NomenclatureEnum